import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BlogPost, CmsUiDynamicContentQuery, CmsUiDynamicContentService, UrlHelperService } from '@lobos/library';
import { first, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-blog-redirect',
  template: ``,
})
export class BlogRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private translocoService: TranslocoService,
    private urlHelper: UrlHelperService,
    private cmsService: CmsUiDynamicContentService,
    private cmsQuery: CmsUiDynamicContentQuery,
  ) {}

  public ngOnInit(): void {
    this.cmsService
      .getBlogPosts()
      .pipe(
        switchMap(() => this.cmsQuery.blogPosts$),
        untilDestroyed(this),
        first(),
        map((blogPosts: BlogPost[]) => this.findBlogPostInIndex(this.urlHelper.getPath().substring(3), blogPosts)),
        map((post?: BlogPost) => {
          if (!post) {
            return [this.translocoService.getActiveLang(), 'not-found'];
          }

          return [this.translocoService.getActiveLang(), 'blog', 'post', post.id];
        }),
      )
      .subscribe(async (commands: any[]) => this.router.navigate(commands, { skipLocationChange: true }));
  }

  private findBlogPostInIndex(path: string, blogPosts: BlogPost[]): BlogPost | undefined {
    return blogPosts.find((post: BlogPost) => post.slug === path);
  }
}
